module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('article', {
    attrs: {
      "epub:type": "chapter"
    }
  }, [_c('div', {
    staticClass: "bodymatter",
    attrs: {
      "epub:type": "bodymatter"
    }
  }, [_c('section', {
    attrs: {
      "epub:type": "division",
      "id": "c07"
    }
  }, [_c('div', {
    staticClass: "chbrd"
  }, [_c('h1', {
    staticClass: "chapter_date"
  }, [_c('a', {
    attrs: {
      "id": "page24"
    }
  }), _c('strong', [_vm._v("c. 525 BCE")])]), _vm._v(" "), _c('h1', {
    staticClass: "chapter_title"
  }, [_vm._v("The Four Noble Truths")]), _vm._v(" "), _c('p', {
    staticClass: "bauthorb"
  }, [_c('strong', [_vm._v("Siddhārtha Gautama (Buddha)")]), _vm._v(" (c. 560–c. 380 BCE)")])]), _vm._v(" "), _c('p', {
    staticClass: "nonindent"
  }, [_vm._v("The foundation of Buddhism is veiled in clouds of myth and uncertainty. What we do know is that Buddhism was founded by Siddhārtha Gautama, who lived and taught in southern Nepal and northern India sometime around the sixth or fifth century BCE. Born the son of a wealthy king, Siddhārtha lived a life of luxury before becoming discontented in his late twenties and deciding to leave home to seek his enlightenment. For six years he practiced meditation and severe bodily austerities but did not find the answers he was looking for. Finally, he sat under a fig tree one day and resolved not to get up until he had achieved enlightenment. At dawn, the Great Awakening occurred and he became Buddha (“the enlightened one”). He gathered a community of disciples and spent the next forty-five years teaching the liberating path he had discovered.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("What was this secret to inner peace that Buddha discovered? It is encapsulated in his “Four Noble Truths”: life is suffering, the cause of suffering is selfish craving ("), _c('em', [_vm._v("tanha")]), _vm._v("), suffering can be overcome, and the way to overcome suffering is by following the Eightfold Path (right views, right aspiration, right livelihood, and other beliefs and practices that signal a serious commitment to the Buddhist lifestyle and path of liberation).")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Though Buddhism has become encrusted with speculative doctrine, Buddha himself always maintained a “noble silence” about metaphysical issues. One of his disciples commented, “Whether the world is eternal or not eternal, whether the world is finite or not, whether the soul is the same as the body or whether the soul is one thing and the body another . . . the Lord does not explain to me.” What Buddha taught was a practical therapy for rooting out the persistent causes of unhappiness and discontent. He recognized that people live in chains forged by their own hands. We suffer because we are self-centered and thirst after empty pleasures and things we cannot have. Once we liberate ourselves from all clutching desires, we are free, Buddha said, to “cultivate love without measure toward all beings.”")]), _vm._v(" "), _c('p', {
    staticClass: "captionl",
    attrs: {
      "id": "img25"
    }
  }, [_c('em', [_vm._v("Buddha is said to have reached enlightenment under a fig tree (a sacred tree whose name in Sanskrit is “Bodhi,” or")]), _vm._v(" enlightenment, "), _c('em', [_vm._v("tree) in Bodh Gaya, India, the most sacred city in Buddhism. The Great Buddha statue of Bodh Gaya is shown here; completed in 1989, it stands 80 feet (25 meters) tall.")])]), _vm._v(" "), _c('div', {
    staticClass: "dis_imgb"
  }, [_c('a', {
    attrs: {
      "id": "page25"
    }
  }), _c('img', {
    attrs: {
      "alt": "",
      "src": "OEBPS/images/25-1.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "xref"
  }, [_c('p', {
    staticClass: "seal"
  }, [_c('span', {
    staticClass: "sls"
  }, [_c('strong', [_vm._v("SEE ALSO")])]), _vm._v(" "), _c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9781454935575_c01"
    }
  }, [_vm._v("The Vedas (c. 1500 BCE)")]), _vm._v(", "), _c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9781454935575_c08"
    }
  }, [_vm._v("No-Self ("), _c('em', [_vm._v("Anatta")]), _vm._v(") (c. 525 BCE)")]), _vm._v(", "), _c('span', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9781454935575_c42",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Stoicism (c. 300 BCE)")])])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2c2788fd","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OEBPS/9781454935575_c07.vue
// module id = 93
// module chunks = 0